import { api } from "../api";

export const getProjectActivityFeed = async (projectId, cursor, limit = 20) => {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  const response = await api.get(`/projects/${projectId}/activity-feed`, { params });
  return response.data;
};
